export default{
	_API_:"https://schapi.zafu.edu.cn/data/statistics/api/"
}